var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',{attrs:{"icon-name":"guides"}},[_c('path',{staticClass:"grayStroke",attrs:{"d":"M5,4 19,20","opacity":"0.5"}}),_c('circle',{staticClass:"whiteFill blueStroke",attrs:{"r":"3","cy":"14","cx":"14"}})])}
var staticRenderFns = []

export { render, staticRenderFns }